import { render, staticRenderFns } from "./ComponenteGrafica.vue?vue&type=template&id=ec58850a&scoped=true&lang=es"
import script from "./ComponenteGrafica.vue?vue&type=script&lang=js"
export * from "./ComponenteGrafica.vue?vue&type=script&lang=js"
import style0 from "./ComponenteGrafica.vue?vue&type=style&index=0&id=ec58850a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec58850a",
  null
  
)

export default component.exports